import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Product } from '@spartacus/core';

@Component({
    selector: 'app-uig-availability',
    templateUrl: './uig-availability.component.html',
    styleUrls: ['./uig-availability.component.scss'],
    standalone: false
})
export class UigAvailabilityComponent implements OnChanges {

  @Input() product: Product;
  @Input() iconOnly: boolean = false;

  status: string;
  nextDeliveryTimeCW: number;
  stockLevel: number;
  stockText: string;

  constructor() { }

  ngOnChanges() {
    if (this.product) {
      if(this.product.stock?.stockLevel > this.product.stock?.availabilityDisplayAmountLimit) {
        this.stockLevel = this.product.stock?.availabilityDisplayAmountLimit;
        if(this.product.stock?.checkOrder) {
          this.stockText = "product.availableAmountMaxCheck";
          this.status = "unclearAvailability_yellow"
        }
        else {
          this.stockText = "product.availableAmountMax";
        }        
      }
      else {
        this.stockLevel = this.product.stock?.stockLevel;
        this.stockText = "product.availableAmount";
      }
      
      if(this.stockLevel == 0) {
        var hasNextDeliveryTimeCW = this.product.stock?.nextDeliveryTimeCW > 0;
        if(hasNextDeliveryTimeCW) {
          this.status = "notDeliverable";
          this.nextDeliveryTimeCW = this.product.stock.nextDeliveryTimeCW;
        }
        else {
          this.status = "unclearAvailability";
        }
      }
      else if(this.product.stock?.stockLevelStatus === 'inStock'){
        this.status = "available";
      }
    }
  }

}
